import urls from "venuescanner-js/routes/urls-es";
import Controller from "./controller";
// console.log(urls)
const controllers = Object.keys(urls).reduce((acc, name) => {
  acc[name] = new Controller(urls[name]);
  return acc;
}, {});

export default controllers;
